import styled from 'styled-components';

const ErrorList = styled.ul`
  margin-bottom: 0;
`;

export default ErrorList;
